module.exports = __webpack_public_path__ + "static/media/detail10.afbaa8af.jpg";